import React from "react";
import {
	Container,
	Box,
	Typography,
	Grid,
	Divider,
	Card,
	CardMedia,
	CardContent,
} from "@mui/material";
import { Link } from "react-router-dom";
import trader from "../assets/expert.jpg";
import tradephone from "../assets/tradephone.jpg";
import mine from "../assets/mine.png";
import aibot from "../assets/aibot.jpg";

const services = [
	{
		title: "Secure & Reliable Trading Platform",
		description:
			"Our platform ensures the highest level of security for your assets with advanced encryption and multi-factor authentication, providing a safe environment for all your crypto transactions.",
		image: trader,
	},
	{
		title: "Real-time Market Data & Insights",
		description:
			"Access live market data, charts, and analytics to make informed trading decisions. Stay ahead with up-to-the-minute updates and expert insights.",
		image: tradephone,
	},
	{
		title: "Advanced Trading Tools",
		description:
			"Utilize a range of advanced tools including leverage, stop-loss, and take-profit features to optimize your trading strategies and maximize profits.",
		image: mine,
	},
	{
		title: "Educational Resources & Support",
		description:
			"Empower your trading journey with comprehensive tutorials, webinars, and dedicated customer support to help you succeed in the crypto market.",
		image: aibot,
	},
];

const ServicePage = () => {
	return (
		<Container maxWidth="lg" sx={{ py: 2 }}>
			<Box
				sx={{
					bgcolor: "white",
					color: "black",
					py: 8,
					mt: "4rem",
					textAlign: "center",
					position: "relative",
					mb: "3rem",
				}}>
				<Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
					Services
				</Typography>
				<Divider
					sx={{
						bgcolor: "black",
						my: "0.5rem",
						width: "5rem",
						marginX: "auto",
					}}
				/>
				<Typography
					variant="h6"
					sx={{
						maxWidth: 600,
						marginX: "auto",
						mb: "5rem",
						color: "#27282A",
						px: "2rem",
					}}>
					Providing expert crypto trading, secure investment solutions,
					responsible financial management, and innovative trading technologies
					to help you succeed in the digital economy.
				</Typography>
				<div class="custom-shape-divider-bottom-1760310926">
					<svg
						data-name="Layer 1"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 1200 120"
						preserveAspectRatio="none">
						<path
							d="M1200,0H0V120H281.94C572.9,116.24,602.45,3.86,602.45,3.86h0S632,116.24,923,120h277Z"
							class="shape-fill"></path>
					</svg>
				</div>
			</Box>

			{/* Page Header */}
			{/* <Box textAlign="center" sx={{ background: "blue", mt: "3rem" }}>
				<Typography
					variant="h3"
					component="h1"
					gutterBottom
					sx={{ fontWeight: "bold", fontSize: "3rem", color: "white" }}>
					Crypto Trading Services
				</Typography>
				<Typography variant="h6" color="textSecondary">
					Empowering your crypto trading experience with cutting-edge tools,
					security, and support.
				</Typography>
			</Box> */}

			{/* Services Grid */}
			<Grid container spacing={4}>
				{services.map((service, index) => (
					<Grid item xs={12} md={6} key={index}>
						<Card
							sx={{
								display: "flex",
								flexDirection: { xs: "column", md: "row" },
								boxShadow: 3,
								bgcolor: "black",
							}}>
							{/* <CardMedia
								component="img"
								sx={{ width: { md: 300 }, height: "auto" }}
								image={service.image}
								alt={service.title}
							/> */}
							<CardContent sx={{ flex: 1, p: 3 }}>
								<Typography
									variant="h5"
									gutterBottom
									sx={{ mb: 2, fontWeight: "bold", color: "white" }}>
									{service.title}
								</Typography>
								<Typography
									variant="body1"
									color="textSecondary"
									sx={{ color: "lightgray" }}>
									{service.description}
								</Typography>
							</CardContent>
						</Card>
					</Grid>
				))}
			</Grid>

			{/* Call to Action */}
			<Box textAlign="center" mt={8} px={2}>
				<Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
					Ready to Trade Crypto Confidently?
				</Typography>
				<Typography variant="h6" color="textSecondary" mb={4}>
					Join thousands of traders leveraging our platform for secure, fast,
					and insightful crypto trading.
					<Link
						to="/en/register"
						className="px-[1rem] py-[0.2rem]  inline-block  text-white min-w-[4rem]  border-2  bg-red-700">
						Get started
					</Link>
				</Typography>
				{/* You can add buttons or links here */}
				{/* Example: */}
				{/* <Button variant="contained" size="large" color="primary">Get Started</Button> */}
			</Box>
		</Container>
	);
};

export default ServicePage;
